import { error } from "jquery";
import { baseURL } from "../../helper/helper";

export async function fetchFeaturedBrandsAPI() {
    const response = await fetch(`${baseURL}/api/version3/featured-brands`);
    if(!response.ok) throw new error("Failed to retch featured brands data");
    return response.json()
}